import { saveStateSession } from '../Components/FlyfishComponents/flyfishutils/utils';
import { ChatSocketRequest, liveRequest } from './models';

export default class WebSocketClient {
	protocol: string;
	hostname: string;
	endpoint: string;
	message: ChatSocketRequest;
	webSocket: WebSocket | undefined;
	onSocketClose: (this: WebSocket, ev: CloseEvent) => any;
	socketListener: (this: WebSocket, ev: MessageEvent) => any;

	constructor(
		protocol: string,
		hostname: string,
		endpoint: string,
		message: ChatSocketRequest,
		onSocketClose: (this: WebSocket, ev: CloseEvent) => any,
		socketListener: (this: WebSocket, ev: MessageEvent) => any
	) {
		this.message = message;
		this.protocol = protocol;
		this.hostname = hostname;
		this.endpoint = endpoint;
		this.webSocket = undefined;
		this.onSocketClose = onSocketClose;
		this.socketListener = socketListener;
	}

	getServerUrl() {
		return this.protocol + '://' + this.hostname + this.endpoint;
	}

	connect() {
		try {
			this.webSocket = new WebSocket(this.getServerUrl());

			this.webSocket.onopen = () => {
				this.send();
				this.websocketEndPointheartbeat();
				saveStateSession('iswebsocketendpoint', 'opened');
			};
			this.webSocket.onmessage = this.socketListener;
			this.webSocket.onerror = (event) => {
				console.log(JSON.stringify(event, null, 4));
			};
			this.webSocket.onclose = this.onSocketClose;
		} catch (exception) {
			console.error(exception);
		}
	}
	websocketEndPointheartbeat() {
		if (!this.webSocket) return;
		if (this.webSocket.readyState === WebSocket.CLOSED) return;
		this.webSocket.send(JSON.stringify({ keepalive: 'true' }));
		setTimeout(() => {
			this.websocketEndPointheartbeat();
		}, 5000);
	}
	send(message?: ChatSocketRequest) {
		if (message) {
			this.message = message;
		}
		if (this.webSocket) {
			if (this.webSocket.readyState === WebSocket.OPEN) {
				this.webSocket.send(JSON.stringify(this.message));
			} else {
				console.error(
					'websocket is not open. readyState = ' + this.webSocket.readyState
				);
			}
		} else {
			console.error('websocket has not been opened.');
		}
	}

	close() {
		if (this.webSocket && this.webSocket.readyState === WebSocket.OPEN) {
			// this.message = {
			//   ...this.message,
			//   message: "",
			// };
			// this.send();
			this.webSocket.close(1000, 'websocketendpoint Socket closing from UI');
		}
	}
}
